import React from 'react';
import { labelValue } from '../Helpers';

interface HoofdfinancierderBoxProps {
    title: string;
    project: {
        mainFundingChannel: {
            id: string;
            modelType: string;
            name: string;
            code: string;
           
        }
        mainDetailedFundingChannel: {
            name: string;
        }
        mainFunderAccount: {
            name: string;
        }
        mainFunderContact: {
            name: string;
        }
    }
}

const HoofdfinancierderBox = ({ title, project } : HoofdfinancierderBoxProps)  => {
    return (
        <div className='box'>

            <h2>{title}</h2>
            <div className='items'>
                {labelValue(project?.mainFundingChannel?.name, "Financiëringskanaal")}
                {labelValue(project?.mainDetailedFundingChannel?.name, "Gedetailleerde Financiëringskanaal")}
                {labelValue(project?.mainFunderAccount?.name, "Account")}
                {labelValue(project?.mainFunderContact?.name, "Contactpersoon")}
            </div>
        </div>
    );
};

export default HoofdfinancierderBox;
